import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.updateActive()
    this.boundUpdate = this.updateActive.bind(this)
    document.addEventListener("turbo:frame-render", this.boundUpdate)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-render", this.boundUpdate)
  }

  updateActive() {
    const path = window.location.pathname
    this.element.querySelectorAll("a.kapri-tree-link").forEach(link => {
      link.classList.toggle("is-active", link.pathname === path)
    })
  }
}
